// extracted by mini-css-extract-plugin
export default {"check":"ApplicationCreatedModal_check__a8Y+N","subtitle":"ApplicationCreatedModal_subtitle__hzDiO","notice":"ApplicationCreatedModal_notice__5+-Mo"};